module.exports = {
          srcSet: __webpack_public_path__ + "38701ee77ba17bb9128a31e7b897aef9-653.jpg"+" 653w",
          images:[ {path: __webpack_public_path__ + "38701ee77ba17bb9128a31e7b897aef9-653.jpg",width: 653,height: 560}],
          src: __webpack_public_path__ + "38701ee77ba17bb9128a31e7b897aef9-653.jpg",
          toString:function(){return __webpack_public_path__ + "38701ee77ba17bb9128a31e7b897aef9-653.jpg"},
          
          width: 653,
          height: 560
        }